// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';

class State {
  open = false;
}

export default class ContentPanel extends React.Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { open } = this.props;
    this.setState({ open });
  }

  handleToggle = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { children, header } = this.props;
    const { open } = this.state;
    const stIcon = open ? 'chevron-up' : 'chevron-down';
    return (
      <PanelGroup id='accordion-example'>
        <Panel defaultExpanded={open}>
          <Panel.Heading>
            <Panel.Toggle
              componentClass='div'
              style={{ fontSize: '18px' }}
              onClick={this.handleToggle}
            >
              <i
                className={`fas fa-${stIcon}`}
                style={{ marginTop: '4px', marginRight: '12px' }}
              />
              {header}
            </Panel.Toggle>
          </Panel.Heading>
          <Panel.Body collapsible>{children}</Panel.Body>
        </Panel>
      </PanelGroup>
    );
  }
}
